export function addHandler(el: HTMLElement | Window | Document, type: string, listener: any, debugName = '') {
	if (!el) { console.warn(`AddHandler:${type}:${debugName}`); return; }
	type.split(' ').forEach((t: string) => { el.addEventListener(t, listener); });
}

export function removeHandler(el: HTMLElement | Window | Document, type: string, listener: any, debugName = '') {
	if (!el) { console.warn(`RemoveHandler:${type}:${debugName}`); return; }
	type.split(' ').forEach((t: string) => { el.removeEventListener(t, listener); });
}
